import { render, staticRenderFns } from "./FranchiseLoginStep.vue?vue&type=template&id=096d5cb3&scoped=true"
import script from "./FranchiseLoginStep.vue?vue&type=script&lang=js"
export * from "./FranchiseLoginStep.vue?vue&type=script&lang=js"
import style0 from "./FranchiseLoginStep.vue?vue&type=style&index=0&id=096d5cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d5cb3",
  null
  
)

export default component.exports